class CollectionDescriptionToggle extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const content = this.querySelector('[data-collection-description-content]');
    const button = this.querySelector('[data-collection-description-toggle]');
    const readMoreLabel = this.querySelector('[data-read-more-label]');
    const readLessLabel = this.querySelector('[data-read-less-label]');

    if (!content || !button) return;

    const collapsedLines = parseInt(this.dataset.collapsedLines || '3', 10);
    content.style.setProperty('--collection-description-lines', collapsedLines);

    const needsToggle = () => {
      if (content.classList.contains('is-expanded')) return true;
      return content.scrollHeight > content.clientHeight + 1;
    };

    const updateButtonState = (expanded) => {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      content.classList.toggle('is-expanded', expanded);

      if (readMoreLabel) readMoreLabel.hidden = expanded;
      if (readLessLabel) readLessLabel.hidden = !expanded;
    };

    const syncCollapsedState = () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) return;

      button.hidden = !(content.scrollHeight > content.clientHeight + 1);
    };

    const measure = () => {
      requestAnimationFrame(syncCollapsedState);
    };

    measure();

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      updateButtonState(expanded);

      if (!expanded) {
        measure();
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => {
        if (button.getAttribute('aria-expanded') !== 'true') {
          syncCollapsedState();
        }
      });
      observer.observe(content);
    }
  }
}

if (!window.customElements.get('collection-description-toggle')) {
  window.customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}
